import { CreditCardDisplay } from '@/components/modules/CreditCard/Detail/Overview/components/CreditCardDisplay';
import { CreditCard } from '@/config/types';

interface CreditCardConditionsSummaryProps {
  creditCard: CreditCard;
}

export const CreditCardConditionsSummary = ({ creditCard }: CreditCardConditionsSummaryProps) => {
  return <CreditCardDisplay creditCardConfiguration={creditCard?.configuration} />;
};
